import { CSSProperties } from 'react';
import { COLORS } from '../../globalStyles';

export const styles: Record<string, CSSProperties> = {
  svg: {
    display: 'block',
    flexShrink: 0,
  },
  cutout: {
    fill: COLORS.markCutout,
  },
  stopFrom: {
    stopColor: COLORS.markFrom,
  },
  stopTo: {
    stopColor: COLORS.markTo,
  },
};
